function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var BlueMoneyIllustrationSvg = function BlueMoneyIllustrationSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 383 705.3"
  }, props), React.createElement("path", {
    d: "M0 689.2C576.5 577 407.4 22 0 16v673.2z",
    fill: "#f8f7fa"
  }), React.createElement("defs", null, React.createElement("path", {
    id: "blue-money-illustration_svg__a",
    d: "M0 0h367.9v705.3H0z"
  })), React.createElement("clipPath", {
    id: "blue-money-illustration_svg__b"
  }, React.createElement("use", {
    xlinkHref: "#blue-money-illustration_svg__a",
    overflow: "visible"
  })), React.createElement("g", {
    clipPath: "url(#blue-money-illustration_svg__b)"
  }, React.createElement("path", {
    fill: "#324b8c",
    d: "M145.4 190h152.5v303H145.4z"
  }), React.createElement("path", {
    d: "M232.3 182.7c0-18.1 14.7-32.8 32.8-32.8s32.8 14.7 32.8 32.8V200h-65.7v-17.3h.1z",
    fill: "#324b8c"
  }), React.createElement("path", {
    d: "M238.8 197c-1.7-4.1-2.7-8.5-2.7-13.2 0-18.7 15.2-33.9 33.9-33.9H131.4c-18.7 0-33.9 15.2-33.9 33.9 0 4.7.9 9.2 2.7 13.2h138.6z",
    fill: "#1e0a3c"
  }), React.createElement("circle", {
    cx: 221.7,
    cy: 296.2,
    r: 48.3,
    fill: "#1e0a3c"
  })), React.createElement("g", null, React.createElement("defs", null, React.createElement("path", {
    id: "blue-money-illustration_svg__c",
    d: "M0 0h367.9v705.3H0z"
  })), React.createElement("clipPath", {
    id: "blue-money-illustration_svg__d"
  }, React.createElement("use", {
    xlinkHref: "#blue-money-illustration_svg__c",
    overflow: "visible"
  })), React.createElement("g", {
    clipPath: "url(#blue-money-illustration_svg__d)"
  }, React.createElement("path", {
    d: "M141.9 512.6s6.2 9.4 10 6.4c3.7-3 46-33.5 46-33.5l3.7-21-41.3-13-18.4 61.1z",
    fill: "#1e0a3c"
  }), React.createElement("path", {
    d: "M80.7 393.4c4.9-12.3 42.6-74.4 55.7-83 13.1-8.7 75-36 79.4-25 7.4 18.5-55.2 35-66.6 51.9-12.5 18.6-21.6 41.5-21.6 41.5l-1.9 7.7c14.7.2 30.9 0 38.7-2.9 12.4-4.5 19.1 9.2 23.9 34.4 0 0 .9 1 1.9 1.3s2 .6 2.9.9c5.9 1.9 8 11.2 9 17.1.4 2.2 1.5 1.5 1.5 1.5 7 1.9 12.7 4.8 15.9 9.2 14.8 20.7-39.4 72.1-47 69.4-14.3-5.2 4.5-20.2 14.5-34.6 6.5-9.4 10.2-18.4 10.2-18.4-14.2 6-33.6 0-33.6 0s-35.1 92.1-39.6 102.5c-4.5 10.4-34.1 22.9-34.1 22.9L-17.7 779.6l-2.1-183.7 44-53s22.1-37.1 31.6-76.6c9.3-38.7 19.4-46.2 20.8-65.1 1.5-19.9 30.5-51.7 30.5-51.7",
    fill: "#f05537"
  }), React.createElement("path", {
    d: "M149.3 437.5s61.7-8.6 75.4 10.4m-95.6-39.5s39.1 2.2 69.1 11.7",
    fill: "none",
    stroke: "#1e0a3c",
    strokeMiterlimit: 10
  }))), React.createElement("path", {
    fill: "#4269f6",
    d: "M25.4 705.3L62.3 652 0 562.4v142.9z"
  }));
};

BlueMoneyIllustrationSvg.displayName = "BlueMoneyIllustrationSvg";
export default BlueMoneyIllustrationSvg;